import { InputProperty, SECTION_TYPE, TabConfig } from './form.model';
import { TennureScreens } from './tenure.model';
import { BrandTenureComponent } from '../components/tenure/brand-tenure/brand-tenure.component';
import { DealersTenureComponent } from '../components/tenure/dealers-tenure/dealers-tenure.component';
import { JobsTenureComponent } from '../components/tenure/jobs-tenure/jobs-tenure.component';
import { LexusGrantTenureComponent } from '../components/tenure/lexus-grant-tenure/lexus-grant-tenure.component';
import { OemTenureComponent } from '../components/tenure/oem-tenure/oem-tenure.component';
import { TtenTenureComponent } from '../components/tenure/tten-tenure/tten-tenure.component';
import { TenureAdjustmentComponent } from '../components/tenure/tenure-adjustment/tenure-adjustment.component';

export const TenureTabIds = {
  Brand: TennureScreens.BrandTenure,
  Dealer: TennureScreens.DealerTenure,
  Job: TennureScreens.JobTenure,
  LexusGrant: TennureScreens.LexusTenure,
  Oem: TennureScreens.OemTenure,
  Ttn: TennureScreens.TtnTenure,
  TenureAdjustment: 'tenureAdjustment'
} as const;

export const TenureBaseTabSchema: TabConfig[] = [
  { label: 'Brand', tabId: TenureTabIds.Brand, type: SECTION_TYPE.FilterWithTable, component: BrandTenureComponent, inputs: { options: {} } as InputProperty },
  { label: 'Dealer', tabId: TenureTabIds.Dealer, type: SECTION_TYPE.FilterWithTable, component: DealersTenureComponent, inputs: { options: {} } as InputProperty },
  { label: 'Job', tabId: TenureTabIds.Job, type: SECTION_TYPE.FilterWithTable, component: JobsTenureComponent, inputs: { options: {} } as InputProperty },
  { label: 'Lexus Grant', tabId: TenureTabIds.LexusGrant, type: SECTION_TYPE.FilterWithTable, component: LexusGrantTenureComponent, inputs: { options: {} } as InputProperty },
  { label: 'OEM', tabId: TenureTabIds.Oem, type: SECTION_TYPE.FilterWithTable, component: OemTenureComponent, inputs: { options: {} } as InputProperty },
  { label: 'T-TEN Only', tabId: TenureTabIds.Ttn, type: SECTION_TYPE.FilterWithTable, component: TtenTenureComponent, inputs: { options: {} } as InputProperty },
];

/** First 3 tabs — Basic Tenure group */
export const TenureBasicTabSchema: TabConfig[] = TenureBaseTabSchema.slice(0, 3);

/** Last 3 tabs — Discretionary Tenure group */
export const TenureDiscretionaryTabSchema: TabConfig[] = TenureBaseTabSchema.slice(3);

export const TenureAdjustmentTabConfig: TabConfig = {
  label: 'Tenure Adjustment',
  tabId: TenureTabIds.TenureAdjustment,
  type: SECTION_TYPE.FilterWithTable,
  component: TenureAdjustmentComponent,
  inputs: {}
};
